import _ from "lodash";
import { IOverviewItem, ITransitionJourneyNodeData, ITransitionJourneyTreeNode, TransitionJourneyNodeType } from "../interfaces/AppInterfaces";
import store from "../redux/store";
import { AGENTIC_MS_USER_INFO, AUTHORIZATION_TOKEN, CREATE_PROJECT_START_DATE_RANGE, ROLES, SELECTED_ASSESSMENT_PARAMS, TABLE_DEFAULT_PAGE_SIZE, TRANSITION_JOURNEY_NODE_SECTION, TRANSITION_JOURNEY_NODE_TYPE, WORK_LOG_ITEM_TYPES, getCurrentUserSelectedRole, userHasRole } from "../constants/appConstants";
import { setTransitionJourneyNodeData, updateNodeActivationStatus } from "../redux/slices/transitionJourneySlice";
import { sampleApplications, sampleArtefacts, sampleAssessments, sampleClosures, sampleKTDetailsData, sampleKTPlan, sampleKnowledgeData, sampleOverviewData, sampleSmtdData } from "../constants/transitionJourneySampleData";
import { getUserInfo } from "./localStorage";
import moment from "moment";
import { msalInstance } from "../auth/authMsal";
import axiosInstance from "../services/axiosInstance";
import { getUserInformation } from "../helpers/AppHelpers";
import { jwtDecode } from "jwt-decode";
import { AUTH_MODE, login } from "../redux/slices/session";
export const generateSecureId = (): string => {
    return String(window.crypto.getRandomValues(new Uint32Array(1))[0]);
};

export const generateTimestampId = (): string => {
    return `${Date.now()}-${window.crypto.getRandomValues(new Uint32Array(1))[0]}`;
};

// export const getProjectStatus = (projectId: string): string => {
//     const state = store.getState();
//     const selectedProject = projectId && state.transitionJourney.projectsData?.data
//         ? (state.transitionJourney.projectsData.data as any[]).find((project: any) => project.id === projectId)
//         : undefined;
//     return selectedProject?.projectStatus || '';
// }


export const getNode = (data: ITransitionJourneyTreeNode[], nodeType: TransitionJourneyNodeType): ITransitionJourneyTreeNode | undefined => {
    let selectedNode = undefined;
    data.forEach((node: ITransitionJourneyTreeNode) => {
        node.children?.forEach((child: ITransitionJourneyTreeNode) => {
            if (child.nodeType === nodeType) {
                selectedNode = child;
            }
        });
    });
    return selectedNode;
};

export const getNodeById = (data: ITransitionJourneyTreeNode[], nodeId: string): ITransitionJourneyTreeNode | undefined => {
    let selectedNode = undefined;
    data.forEach((node: ITransitionJourneyTreeNode) => {
        if (node.id === nodeId) {
            selectedNode = node;
            return;
        }
        node.children?.forEach((child: ITransitionJourneyTreeNode) => {
            if (child.id === nodeId) {
                selectedNode = child;
            }
        });
    });
    return selectedNode;
};

export const setNodeData = (projectId: string, nodeType: TransitionJourneyNodeType, nodeData: ITransitionJourneyNodeData, nodeSectionType: string): void => {
    const data = store.getState().transitionJourney.visitedProjects[projectId].data;
    const node: ITransitionJourneyTreeNode | undefined = _.cloneDeep(getNode(data, nodeType));
    if (node) {
        if (nodeSectionType === TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD && node.dashboard) {
            node.dashboard.data = nodeData;
        } else if (nodeSectionType === TRANSITION_JOURNEY_NODE_SECTION.COLLABORATION && node.collaboration) {
            node.collaboration.data = nodeData;
        } else if (nodeSectionType === TRANSITION_JOURNEY_NODE_SECTION.WORK_LOG && node.workLog) {
            node.workLog.data = nodeData;
        }
        store.dispatch(setTransitionJourneyNodeData({ projectId: projectId, node: node }));
    }

};

export const setConnectorData = (projectId: string, nodeType: TransitionJourneyNodeType, nodeData: ITransitionJourneyNodeData, nodeSectionType: string, connectorType: 'mapped' | 'unmapped' | 'allConnectors' | 'completed'): void => {
    const data = store.getState().transitionJourney.visitedProjects[projectId].data;
    const node: ITransitionJourneyTreeNode | undefined = _.cloneDeep(getNode(data, nodeType));
    if (node) {
        let existingData: ITransitionJourneyNodeData | undefined;

        if (nodeSectionType === TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD && node.dashboard) {
            existingData = node.dashboard.data;
        } else if (nodeSectionType === TRANSITION_JOURNEY_NODE_SECTION.COLLABORATION && node.collaboration) {
            existingData = node.collaboration.data;
        } else if (nodeSectionType === TRANSITION_JOURNEY_NODE_SECTION.WORK_LOG && node.workLog) {
            existingData = node.workLog.data;
        }
        // For allConnectors, clear existing data and replace with new data
        const cleanExistingData = (existingData?.data as any) || {};

        if (connectorType === 'allConnectors') {
            delete cleanExistingData.allConnectors;
        }

        const existingFilterItems = (existingData?.filterItems as any) || {};
        // const connectorFilterData = (nodeData.data as any)?.[connectorType]?.paging_and_filter_data || nodeData.filterItems;
        const connectorFilterData = nodeData.filterItems;
        const updatedFilterItems = {
            ...existingFilterItems,
            [`${connectorType}FilterItems`]: connectorFilterData
        };

        // Use nodeData.data directly as the connector data
        const connectorData = nodeData.data;

        const newData: ITransitionJourneyNodeData = {
            ...existingData,
            overviewItems: existingData?.overviewItems || [],
            filterItems: updatedFilterItems,
            data: {
                ...cleanExistingData,
                [connectorType]: connectorData
            } as any
        };

        if (nodeSectionType === TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD && node.dashboard) {
            node.dashboard.data = newData;
        } else if (nodeSectionType === TRANSITION_JOURNEY_NODE_SECTION.COLLABORATION && node.collaboration) {
            node.collaboration.data = newData;
        } else if (nodeSectionType === TRANSITION_JOURNEY_NODE_SECTION.WORK_LOG && node.workLog) {
            node.workLog.data = newData;
        }

        store.dispatch(setTransitionJourneyNodeData({ projectId: projectId, node: node }));
    }
};

export const setTransitionJourneyData = (projectId: string) => {
    const userInfo = getUserInfo();
    if (!userInfo || !userInfo.roles) {
        return false;
    }
    const userRoles = userInfo.roles;
    //setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.DERIVE_KNOWLEDGE as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleArtefacts), TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD);
    //setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.AUTOMATED_TICKET_ANALYSIS as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleApplications), TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD);
    //setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.KNOWLEDGE_COVERAGE_ASSESSMENT as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleKnowledgeData), TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD);
    // setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.REVIEW_KT_PLAN as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleKTPlan), TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD);
    if (userHasRole(userRoles, ROLES.TRANSITION_DIRECTOR)) {
        // setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.KT_REVIEW as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleKTDetailsData), TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD);
        // setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.PLAYBACK_SESSIONS as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleKTPlan), TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD);
    }
    else {
        // setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.KT_REVIEW as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleKTDetailsData), TRANSITION_JOURNEY_NODE_SECTION.COLLABORATION);
        // setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.PLAYBACK_SESSIONS as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleKTPlan), TRANSITION_JOURNEY_NODE_SECTION.COLLABORATION);
    }

    //setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.KT_STATUS as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleKTPlan), TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD);
    // setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.PLAYBACK_ASSESSMENTS as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleAssessments), TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD);
    //setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.REVIEW_SMTD as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleSmtdData), TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD);
    // setNodeData(projectId, TRANSITION_JOURNEY_NODE_TYPE.TRANSITION_REVIEW as TransitionJourneyNodeType, getTransitionJourneyNodeDataBlankObject([sampleOverviewData.items[0], sampleOverviewData.items[1], sampleOverviewData.items[2]], sampleClosures), TRANSITION_JOURNEY_NODE_SECTION.DASHBOARD);

}

export const getTransitionJourneyNodeDataBlankObject = (overviewItems?: IOverviewItem[], data?: any) => {
    return {
        filterItems: {
            pageNumber: 1,
            searchText: '',
            lobType: 'string',
            applicationType: 'string',
            coverageDuration: 'string',
            totalPages: 1,
            pageSize: TABLE_DEFAULT_PAGE_SIZE
        },
        overviewItems: overviewItems ? overviewItems : [],
        data: data ? data : []
    }
}

export const activateOtherNodes = (projectId: string, activate: boolean = true): void => {
    // Only allow TRANSITION_MANAGER and TRANSITION_DIRECTOR roles to activate nodes
    const currentRole = getCurrentUserSelectedRole();
    if (currentRole !== ROLES.TRANSITION_MANAGER && currentRole !== ROLES.TRANSITION_DIRECTOR) {
        return;
    }

    const state = store.getState().transitionJourney.visitedProjects[projectId];

    if (!state || !state.data) {
        return;
    }

    // Dispatch the activation status update to Redux
    store.dispatch(updateNodeActivationStatus({ projectId, activate }));
};

export function convertAnswersArrayToObject(answersArray: any): any {
    const answers: any[] = [];

    answersArray.forEach((answerGroup: any, index: number) => {
        const selectedAnswer = {
            question_id: answerGroup.questionId,
            selected_answers: answerGroup.selectedAnswer
        }
        answers.push(selectedAnswer);
    });

    return answers;
}

export const getWorkLogFunctionalityNameFromNodeType = (nodeType: TransitionJourneyNodeType): string => {
    switch (nodeType) {
        case TRANSITION_JOURNEY_NODE_TYPE.CONNECTORS: {
            return WORK_LOG_ITEM_TYPES.CONNECTORS;
        }
        case TRANSITION_JOURNEY_NODE_TYPE.DERIVE_KNOWLEDGE: {
            return `${WORK_LOG_ITEM_TYPES.KNOWLEDGE_ARTIFACTS},${WORK_LOG_ITEM_TYPES.SOPS},${WORK_LOG_ITEM_TYPES.SMTDS},${WORK_LOG_ITEM_TYPES.TICKETS},${WORK_LOG_ITEM_TYPES.SUMMARY_DOCUMENTS}`;
        }
        case TRANSITION_JOURNEY_NODE_TYPE.AUTOMATED_TICKET_ANALYSIS: {
            return WORK_LOG_ITEM_TYPES.TICKETS;
        }
        case TRANSITION_JOURNEY_NODE_TYPE.KNOWLEDGE_COVERAGE_ASSESSMENT: {
            return `${WORK_LOG_ITEM_TYPES.KNOWLEDGE_ASSESSMENTS},${WORK_LOG_ITEM_TYPES.SOPS},${WORK_LOG_ITEM_TYPES.SMTDS},${WORK_LOG_ITEM_TYPES.GAPS},${WORK_LOG_ITEM_TYPES.APP_QUESTIONS}`;
        }
        case TRANSITION_JOURNEY_NODE_TYPE.KT_STATUS: {
            return `${WORK_LOG_ITEM_TYPES.KT_STATUS},${WORK_LOG_ITEM_TYPES.KT_TOPICS},${WORK_LOG_ITEM_TYPES.KT_SESSIONS},${WORK_LOG_ITEM_TYPES.GAPS}`;
        }
        case TRANSITION_JOURNEY_NODE_TYPE.KT_REVIEW: {
            return `${WORK_LOG_ITEM_TYPES.KT_REVIEW},${WORK_LOG_ITEM_TYPES.KT_SESSIONS},${WORK_LOG_ITEM_TYPES.SOPS},${WORK_LOG_ITEM_TYPES.SMTDS},${WORK_LOG_ITEM_TYPES.GAPS}`;
        }
        case TRANSITION_JOURNEY_NODE_TYPE.PLAYBACK_SESSIONS: {
            return WORK_LOG_ITEM_TYPES.PLAYBACK_SESSIONS;
        }
        case TRANSITION_JOURNEY_NODE_TYPE.PLAYBACK_ASSESSMENTS: {
            return WORK_LOG_ITEM_TYPES.PLAYBACK_ASSESSMENT;
        }
        case TRANSITION_JOURNEY_NODE_TYPE.REVIEW_SMTD: {
            return WORK_LOG_ITEM_TYPES.SMTDS;
        }
        case TRANSITION_JOURNEY_NODE_TYPE.TRANSITION_REVIEW: {
            return WORK_LOG_ITEM_TYPES.TRANSITION_REVIEW;
        }
        case TRANSITION_JOURNEY_NODE_TYPE.PROJECT_DETAILS: {
            return WORK_LOG_ITEM_TYPES.PROJECT;
        }
        default:
            return '';
    }
}

export const setSelectedAssessmentParams = (value: any) => {
    sessionStorage.setItem(SELECTED_ASSESSMENT_PARAMS, JSON.stringify(value));
}

export const getSelectedAssessmentParams = () => {
    const selectedAssessmentParams = sessionStorage.getItem(SELECTED_ASSESSMENT_PARAMS);
    if (selectedAssessmentParams) {
        return JSON.parse(selectedAssessmentParams);
    }
    return null;

}

export const formatDate = (dateStringUTC: string) => {
    if (!dateStringUTC) return '';
    try {
        const dateString = moment.utc(dateStringUTC).local();
        const date = new Date(dateString.toString());
        const formattedDate = date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
        const formattedTime = date.toLocaleTimeString('en-US', {
            hour12: true,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
        return `${formattedDate} · ${formattedTime}`;
    } catch {
        return '';
    }
};

export function arraysEqual(a: Array<any>, b: Array<any>) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

export const checkEquals = (a: any, b: any): boolean => {
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length === 0 || b.length === 0) {
            return true;
        }
        return arraysEqual(a, b);
    }
    return a === b;
}

export const shouldLoadData = (levelValue: string, pageNumber: number, currentPage: number, isLoading: boolean, nodeType: TransitionJourneyNodeType, projectId: string, selectedLevel?: string, selectedLevelValue?: string | string[], level?: string, appliedFilters?: any, search_filter?: any, isRefreshView: boolean = false): boolean => {
    if (!selectedLevel || !selectedLevelValue) {
        return false;
    }
    if (nodeType === TRANSITION_JOURNEY_NODE_TYPE.PLAYBACK_ASSESSMENTS) {
        if (Array.isArray(selectedLevelValue) && (Array.isArray(levelValue) || !levelValue)) {
            const shouldLoad = ((selectedLevel !== level || !(checkEquals(selectedLevelValue, levelValue)) || currentPage !== pageNumber || isRefreshView) && !isLoading);
            return shouldLoad;
        }
        return false;
    }
    const shouldLoad = (selectedLevel !== level || selectedLevelValue !== levelValue || currentPage !== pageNumber || appliedFilters !== search_filter) && !isLoading;
    return shouldLoad;
}
export const updateXml = (text: string): string => {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
};

export const getMinProjectStartDate = (startDateRange: number): string => {
    return moment().subtract(startDateRange, 'days').format('YYYY-MM-DD');
};

export const getMinProjectEndDate = (projectStartDate: string | undefined, dateDiff: number): string => {
    if (!projectStartDate) {
        return moment().add(dateDiff, 'days').format('YYYY-MM-DD');
    }
    const startDate = moment(projectStartDate);
    const today = moment().startOf('day');
    const daysDiff = today.diff(startDate.clone().startOf('day'), 'days');

    if (daysDiff <= CREATE_PROJECT_START_DATE_RANGE && daysDiff > 0) {
        return startDate.add(dateDiff, 'days').format('YYYY-MM-DD');
    } else if (daysDiff === 0) {
        return today.add(dateDiff, 'days').format('YYYY-MM-DD');
    } else {
        return startDate.add(dateDiff, 'days').format('YYYY-MM-DD');
    }
};

export const logoutFromAzure = async () => {
    const account = msalInstance.getAllAccounts()[0];
    // const logoutRequest: EndSessionRequest = {
    //     account, // optional but recommended
    //     postLogoutRedirectUri: window.location.origin,
    // };
    // await msalInstance.logoutRedirect(logoutRequest);
    localStorage.setItem('AGENTIC_MS_LOGGED_OUT', 'true');
    await msalInstance.clearCache({ account: account || undefined });
    window.location.href = window.location.origin;
}

const setToken = (token: any) => {
    sessionStorage.removeItem(AUTHORIZATION_TOKEN);
    sessionStorage.setItem(AUTHORIZATION_TOKEN, token);
    const userInformation = getUserInformation(token);
    sessionStorage.setItem(AGENTIC_MS_USER_INFO, JSON.stringify(userInformation));
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export const setTokenAndAddLoginSession = (response: any) => {
    const payload: any = jwtDecode(response.idToken);
    const userInformation = getUserInformation(response.idToken);
    if (store) {
        store.dispatch(
            login({
                authMode: AUTH_MODE.AZURE,
                token: response.idToken,
                name: _.get(payload, 'name', response.account.name),
                userName: response.account.username,
                roles: userInformation.roles,
                expires_in: userInformation.expires_in,
                issued_at: userInformation.issued_at,
            })
        );
    }
    setToken(response.idToken);
}